import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import FloatingBubbles from '../components/FloatingBubbles';
import axios from 'axios';

export default function VerifyEmailPending() {
  const { user, token, API, logout } = useAuth();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSent(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FloatingBubbles />
      <div style={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ width: '100%', maxWidth: '480px', background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '48px 32px', boxShadow: '0 8px 32px rgba(43,108,176,0.12)', border: '1px solid rgba(190,227,248,0.4)', textAlign: 'center' }}>
          <div style={{ fontSize: '56px', marginBottom: '16px' }}>📧</div>
          <h1 style={{ fontSize: '26px', fontWeight: 800, color: 'var(--dark)', marginBottom: '12px', letterSpacing: '-0.5px' }}>Vérifie ton email</h1>
          <p style={{ fontSize: '15px', color: 'var(--text)', lineHeight: 1.7, marginBottom: '8px' }}>
            Un email de vérification a été envoyé à
          </p>
          <p style={{ fontSize: '15px', fontWeight: 700, color: 'var(--blue)', marginBottom: '24px' }}>
            {user?.email}
          </p>
          <p style={{ fontSize: '14px', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '32px' }}>
            Clique sur le lien dans l'email pour activer ton compte. Vérifie aussi tes spams.
          </p>

          {sent ? (
            <div style={{ background: '#F0FFF4', border: '1px solid #68D391', borderRadius: '12px', padding: '14px 20px', fontSize: '14px', color: '#276749', fontWeight: 600, marginBottom: '20px' }}>
              ✅ Email renvoyé ! Vérifie ta boîte mail.
            </div>
          ) : (
            <button onClick={handleResend} disabled={loading} style={{ background: 'var(--blue)', color: '#fff', border: 'none', padding: '13px 28px', borderRadius: '24px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(43,108,176,0.3)', marginBottom: '16px', opacity: loading ? 0.7 : 1, display: 'block', width: '100%' }}>
              {loading ? 'Envoi...' : '📨 Renvoyer l\'email de vérification'}
            </button>
          )}

          <button onClick={logout} style={{ background: 'transparent', color: 'var(--muted)', border: '1px solid var(--border)', padding: '10px 24px', borderRadius: '24px', fontSize: '13px', cursor: 'pointer', width: '100%' }}>
            Se déconnecter
          </button>
        </div>
      </div>
    </>
  );
}
